module.exports = __webpack_public_path__ + "static/media/PoppinsMedium.bf59c687.ttf";